"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const components_1 = require("@/components");
const constants_1 = __importDefault(require("@/constants"));
const styles_scss_1 = __importDefault(require("./styles.scss"));
const PaymentPortalSessionErrorsModal = ({ paymentPortalSessionError, onClearError }) => {
    const onClose = () => {
        onClearError();
        components_1.modalEvents.remove();
    };
    return (react_1.default.createElement(components_1.ModalTemplate, { title: constants_1.default.general.anErrorOccurred, onClose: onClose, ariaLabel: constants_1.default.general.anErrorOccurred, width: 630 },
        react_1.default.createElement("p", { className: styles_scss_1.default.original }, paymentPortalSessionError)));
};
exports.default = PaymentPortalSessionErrorsModal;
